import { all, update, remove } from '../services/restApi'
import { message } from 'antd'
message.config({top: 110, duration: 4});
const _ = require('underscore')

const limit = 50;

export default {
	namespace : 'adonType',
	state : {
		adonTypes: [],
		skip: 0,
		limit: limit,
		total_items: 0,
	},
	subscriptions : {
		setup({dispatch, history}) {

			history.listen(location => {
		        if (location.pathname === '/catalogs/adons_type') {
		          	dispatch({type: 'firstLoad'})
		        }
		    })
		}
	},
	effects : {
		*query({payload}, {call, put}) {
			yield put({type: 'app/showLoadingTable'})

			try {
				// Model
				const data = {...payload, include: 'hotel'};

				const resp = yield call(all, 'AdonType', data)
				const adonTypes = resp.results;

				yield put({ type: 'querySuccess', payload: {
					adonTypes: adonTypes,
					skip: payload.skip + limit,
					total_items: resp.count
				}})

			} catch (e) {
				if (e && e.data) message.error(e.data.error);
				else message.error('Ha ocurrido un error. Intente más tarde')
			}

			yield put({type: 'app/hideLoadingTable'})
		},
		*update({payload}, {call, put}) {
			yield put({type: 'app/showButtonLoading'})

			try {

				let data = {...payload}
				data.hotel = {__type: 'Pointer', className: 'Hotel', objectId: payload.hotel.objectId};

				if (data.parent_category)
					data.parent_category = {__type: 'Pointer', className: 'AdonType', objectId: payload.parent_category.objectId};

				data = _.omit(data, ['objectId', 'createdAt', 'updatedAt']);

				yield call(update, 'AdonType', payload.objectId, data);
				message.success('Se ha actualizado el registro exitosamente');

			} catch (e) {
				if (e && e.data) message.error(e.data.error);
				else message.error('Ha ocurrido un error. Intente más tarde')	
			}

			yield put({type: 'app/hideButtonLoading'})

		},
		*removeItem({payload}, {call, put}) {
			yield put({type: 'app/showLoadingTable'})

			try {
				yield call(remove, 'AdonType', payload.objectId);
				yield put({type: 'removeSuccess', payload: payload})

			} catch (e) {
				if (e && e.data) message.error(e.data.error);
				else message.error('Ha ocurrido un error. Intente más tarde')	
			}

			yield put({type: 'app/hideLoadingTable'})

		}
	},
	reducers : {
		queryFirst(state, action) {
			return {
				...state,
				...action.payload
			}
		},
		querySuccess(state, action) {
			return {
				...state,
				adonTypes: state.adonTypes.concat(action.payload.adonTypes),
				skip: action.payload.skip,
				total_items: action.payload.total_items
			}
		},
		filterSuccess(state, action) {
			return {
				adonTypes: action.payload.adonTypes,
				skip: 0,
				total_items: action.payload.total_items
			}
		},
		createSuccess(state, action) {
			return {
				...state,
    			adonTypes: [action.payload, ...state.adonTypes]
			}
		},
		updateSuccess(state, action) {
			const obj = _.find(state.adonTypes, {objectId: action.payload.objectId})
			_.extend(obj, action.payload)

			return {
				...state,
    			...action.payload
			}
		},
		removeSuccess(state, action) {

			let adon = {};

			// Identificamos si el registro contiene hijos (es decir es una categoría principal)
			// o es no contiene hijos (es una categoría hijo)
			if (action.payload.type === 'principal')
				adon = _.find(state.adonTypes, {objectId: action.payload.objectId});
			else
				adon = _.find(state.adonTypes, {objectId: action.payload.parent_category.objectId});


			if ((adon.children && adon.children.length === 0) || !adon.children) {
				// Si no contiene hijos, entonces eliminamos la categoría principal
				state.adonTypes = _.without(state.adonTypes, _.find(state.adonTypes, {objectId: adon.objectId}));

			} else {
				// Si contiene hijos, entonces eliminamos la categoría hija
				let children = _.find(adon.children, {objectId: action.payload.objectId});
				adon.children = _.without(adon.children, children);
			}

			return {
				...state,
    			adonTypes: state.adonTypes
			}
		}
	}
}


// WEBPACK FOOTER //
// ./src/models/adonType.js